import FetchApi from "../util/fetchApi";
const fetchApi = new FetchApi();

export default class BusinessRules {
  async getRules(Workspace_id, postData) {
    let { page, limit, components } = postData;
    return (
      await fetchApi.get(
        `/businessRules/${Workspace_id}/?limit=${limit}&page=${page}&components=${JSON.stringify(components)}`
      )
    ).data;
  }

  async getComponents(Workspace_id) {
    return (await fetchApi.get(`/businessRules/${Workspace_id}/components`)).data;
  }
}
